export default function CallBeforeAfter() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-magic-line"></i>
            Фирменный разбор
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Разбор реального звонка: до и после обучения
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Один и тот же сценарий, один и тот же клиент — но два совершенно разных результата. Посмотрите, как меняется разговор после освоения навыков управления телефонной продажей.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 mb-12">
          <div className="bg-white rounded-2xl border border-red-100 overflow-hidden">
            <div className="bg-red-50 px-6 py-4 flex items-center gap-3">
              <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-close-line text-red-500"></i>
              </div>
              <span className="font-bold text-red-700">Как обычно говорит менеджер</span>
            </div>
            <div className="p-6 space-y-4">
              <div className="bg-red-50/50 rounded-lg p-4">
                <p className="text-sm font-semibold text-gray-500 mb-1">Менеджер:</p>
                <p className="text-sm text-gray-700 leading-relaxed">Здравствуйте, меня зовут Иван, компания «Ромашка». Мы занимаемся поставками оборудования. Я хотел бы рассказать вам о наших новых решениях для автоматизации склада. У нас есть очень выгодное предложение, скидка 15% до конца месяца...</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-sm font-semibold text-gray-500 mb-1">Клиент:</p>
                <p className="text-sm text-gray-700 leading-relaxed">Спасибо, нам ничего не нужно. Пришлите информацию на почту.</p>
              </div>
              <div className="bg-red-50/50 rounded-lg p-4">
                <p className="text-sm font-semibold text-gray-500 mb-1">Менеджер:</p>
                <p className="text-sm text-gray-700 leading-relaxed">Но у нас действительно уникальное решение, мы работаем с крупнейшими компаниями в вашей отрасли. Давайте я всё-таки расскажу подробнее, это займёт всего 5 минут...</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-sm font-semibold text-gray-500 mb-1">Клиент:</p>
                <p className="text-sm text-gray-700 leading-relaxed">Нет, извините, я занят. До свидания.</p>
              </div>
              <div className="bg-red-50/50 rounded-lg p-4 text-center">
                <p className="text-sm text-red-600 font-semibold">Результат: клиент повесил трубку, встреча не назначена.</p>
              </div>
            </div>
            <div className="px-6 pb-6">
              <div className="bg-red-50 rounded-lg p-4">
                <p className="text-xs font-semibold text-red-600 mb-2">Типичные ошибки:</p>
                <ul className="space-y-1.5">
                  <li className="flex items-start gap-2 text-xs text-gray-600">
                    <i className="ri-close-circle-line text-red-400 mt-0.5 flex-shrink-0"></i>
                    Самопрезентация вместо вовлечения — разговор начат с монолога о себе
                  </li>
                  <li className="flex items-start gap-2 text-xs text-gray-600">
                    <i className="ri-close-circle-line text-red-400 mt-0.5 flex-shrink-0"></i>
                    Нет вопроса о клиенте — менеджер не пытается понять потребность
                  </li>
                  <li className="flex items-start gap-2 text-xs text-gray-600">
                    <i className="ri-close-circle-line text-red-400 mt-0.5 flex-shrink-0"></i>
                    Ранняя презентация — продукт предлагается до выявления задачи
                  </li>
                  <li className="flex items-start gap-2 text-xs text-gray-600">
                    <i className="ri-close-circle-line text-red-400 mt-0.5 flex-shrink-0"></i>
                    Давление — попытка продавить после первого же отказа
                  </li>
                  <li className="flex items-start gap-2 text-xs text-gray-600">
                    <i className="ri-close-circle-line text-red-400 mt-0.5 flex-shrink-0"></i>
                    Отсутствие следующего шага — разговор закончен без договорённости
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl border border-teal-100 overflow-hidden">
            <div className="bg-teal-50 px-6 py-4 flex items-center gap-3">
              <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-check-line text-teal-600"></i>
              </div>
              <span className="font-bold text-teal-700">Тот же разговор после обучения</span>
            </div>
            <div className="p-6 space-y-4">
              <div className="bg-teal-50/50 rounded-lg p-4">
                <p className="text-sm font-semibold text-gray-500 mb-1">Менеджер:</p>
                <p className="text-sm text-gray-700 leading-relaxed">Иван, добрый день. Вовремя? У меня буквально 40 секунд — вопрос по складской логистике. Вы открыты к короткому разговору?</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-sm font-semibold text-gray-500 mb-1">Клиент:</p>
                <p className="text-sm text-gray-700 leading-relaxed">Смотря о чём. Слушаю.</p>
              </div>
              <div className="bg-teal-50/50 rounded-lg p-4">
                <p className="text-sm font-semibold text-gray-500 mb-1">Менеджер:</p>
                <p className="text-sm text-gray-700 leading-relaxed">Мы помогаем компаниям сократить время сборки заказа на 30-40% без замены WMS. С какими потерями на сборке вы сталкивались за последний квартал?</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-sm font-semibold text-gray-500 mb-1">Клиент:</p>
                <p className="text-sm text-gray-700 leading-relaxed">Ну, ошибки комплектации бывают. А что, у вас есть кейсы именно по складам?</p>
              </div>
              <div className="bg-teal-50/50 rounded-lg p-4">
                <p className="text-sm font-semibold text-gray-500 mb-1">Менеджер:</p>
                <p className="text-sm text-gray-700 leading-relaxed">Да, три проекта в логистике за этот год. Чтобы не отнимать время сейчас — давайте созвонимся в среду или четверг на 20 минут, я покажу цифры. Вам когда удобнее?</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-sm font-semibold text-gray-500 mb-1">Клиент:</p>
                <p className="text-sm text-gray-700 leading-relaxed">Давайте в четверг, в 11. Пришлите пока информацию на почту.</p>
              </div>
              <div className="bg-teal-50/50 rounded-lg p-4 text-center">
                <p className="text-sm text-teal-600 font-semibold">Результат: назначена встреча на четверг 11:00, контакт продолжен.</p>
              </div>
            </div>
            <div className="px-6 pb-6">
              <div className="bg-teal-50 rounded-lg p-4">
                <p className="text-xs font-semibold text-teal-600 mb-2">Что сработало:</p>
                <ul className="space-y-1.5">
                  <li className="flex items-start gap-2 text-xs text-gray-600">
                    <i className="ri-checkbox-circle-line text-teal-500 mt-0.5 flex-shrink-0"></i>
                    Уважение к времени — обозначены временные рамки и запрос разрешения
                  </li>
                  <li className="flex items-start gap-2 text-xs text-gray-600">
                    <i className="ri-checkbox-circle-line text-teal-500 mt-0.5 flex-shrink-0"></i>
                    Ценность в первом предложении — конкретная выгода, а не рассказ о компании
                  </li>
                  <li className="flex items-start gap-2 text-xs text-gray-600">
                    <i className="ri-checkbox-circle-line text-teal-500 mt-0.5 flex-shrink-0"></i>
                    SPIN-вопрос — вовлекающий вопрос, заставляющий клиента задуматься
                  </li>
                  <li className="flex items-start gap-2 text-xs text-gray-600">
                    <i className="ri-checkbox-circle-line text-teal-500 mt-0.5 flex-shrink-0"></i>
                    Социальное доказательство — ссылка на кейсы, а не на продукт
                  </li>
                  <li className="flex items-start gap-2 text-xs text-gray-600">
                    <i className="ri-checkbox-circle-line text-teal-500 mt-0.5 flex-shrink-0"></i>
                    Альтернативный вопрос для закрытия — «среда или четверг» вместо «может, встретимся?»
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center">
          <p className="text-lg text-gray-700 font-semibold">
            Разница не в продукте. Разница — в навыке управления разговором.
          </p>
        </div>
      </div>
    </section>
  );
}